<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_7"></a>
<p class="parttitle">EASTERN APPROACHES</p>
<a id="page_8"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Part_01.vue?c16f0dea